export default __webpack_public_path__ + "static/media/logo.ee97b710.png";